import styled from 'styled-components';

export const TooltipLabelStyles = styled.div`
	.tooltip-label {
		display: flex;
		align-items: center;
		gap: 8px;
		& > div {
			display: flex;
			align-items: center;
			button {
				padding: 0 !important;
				min-height: 0;
				min-width: 0;
				& > div:last-of-type {
					width: unset;
					height: unset;
				}
			}
		}
	}
`;
